
const MiniAvatar = ({ className, color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"      
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path  
        fill={color}      
        d="M10 9.5C8.80653 9.5 7.66193 9.02589 6.81802 8.18198C5.97411 7.33807 5.5 6.19347 5.5 5C5.5 3.80653 5.97411 2.66193 6.81802 1.81802C7.66193 0.974106 8.80653 0.5 10 0.5C11.1935 0.5 12.3381 0.974106 13.182 1.81802C14.0259 2.66193 14.5 3.80653 14.5 5C14.5 6.19347 14.0259 7.33807 13.182 8.18198C12.3381 9.02589 11.1935 9.5 10 9.5ZM0.5 18C0.5 16.0771 0.980609 14.7268 1.85432 13.8537C2.72808 12.9804 4.07948 12.5 6.004 12.5H14C15.9229 12.5 17.2733 12.9804 18.1464 13.8536C19.0196 14.7267 19.5 16.0771 19.5 18C19.5 18.5893 19.3529 18.9397 19.1463 19.1463C18.9397 19.3529 18.5893 19.5 18 19.5H2C1.41067 19.5 1.06026 19.3529 0.853678 19.1463C0.647096 18.9397 0.5 18.5893 0.5 18Z"
      />
    </svg>
  );
};

export default MiniAvatar;
